// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__F85V2","noContent":"styles_noContent__2dcei"};